import { useI18n } from 'vue-i18n'
import type { Ref } from 'vue'

// Password validation: min 8 chars, at least one uppercase, one lowercase, one special character
const PASSWORD_PATTERN = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[\W_]).{8,}$/

export function usePasswordValidation () {
    const { t } = useI18n()

    function validatePassword (
        inputRef: Ref<HTMLInputElement | null>,
        password: string
    ): boolean {
        if (!inputRef.value) return true

        if (password && !PASSWORD_PATTERN.test(password)) {
            inputRef.value.setCustomValidity(t('customer.passwordValidation.passwordInvalid'))
            return false
        }

        inputRef.value.setCustomValidity('')
        return true
    }

    return {
        PASSWORD_PATTERN,
        validatePassword
    }
}
